import { FirestoreDocUser, PlaidItemSafe } from "breadcommon";
import { createContext, useEffect, useState } from "react";
import { firestorePlaidItemsSubscribe } from "./firestoreIo";

export const PlaidItemsContext = createContext<Map<string, PlaidItemSafe>>(
  new Map(),
);

export function PlaidItemsContextProvider(props: {
  children: JSX.Element;
  user: FirestoreDocUser;
  markInitialLoadComplete: () => void;
}): JSX.Element {
  const [plaidItems, setPlaidItems] = useState<Map<string, PlaidItemSafe>>(
    new Map(),
  );

  useEffect(() => {
    return firestorePlaidItemsSubscribe(
      props.user.uid,
      setPlaidItems,
      props.markInitialLoadComplete,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user.uid]);

  return (
    <PlaidItemsContext.Provider value={plaidItems}>
      {props.children}
    </PlaidItemsContext.Provider>
  );
}
